import type { LocalizationMap } from './Localization/Localization';
// ------------------------------------------------------------------------------------------------
export const enum QueryBuilderUILabelKey {
    Update_Query = 'tooltip_update_query',
    Add_Group = 'tooltip_add_group',
    Add_Rule = 'tooltip_add_rule',
    Delete = 'tooltip_delete',
    Clear_All = 'tooltip_clear_all'
}
// ------------------------------------------------------------------------------------------------
export const QueryBuilderLocalizationTextMapKey: string = "Primitive_QueryBuilder";
// ------------------------------------------------------------------------------------------------
export function GetQueryBuilderLocalizationDictionary(): LocalizationMap {
    return {
        [QueryBuilderUILabelKey.Update_Query]: 'Send to output',
        [QueryBuilderUILabelKey.Add_Group]: 'Add group',
        [QueryBuilderUILabelKey.Add_Rule]: 'Add rule',
        [QueryBuilderUILabelKey.Delete]: 'Delete',
        [QueryBuilderUILabelKey.Clear_All]: 'Clear all'
    };
}
// ------------------------------------------------------------------------------------------------